import { event as biEventVOD, sendError as biSendError } from 'shared/bi/bi-vod';
import biEventsCatalog from 'shared/bi/bi-events-catalog';
import biErrorsCatalog from 'shared/bi/bi-errors-catalog';


export function sendEvent(nameFromCatalog, params) {
  return Promise.resolve().then(() => {
    // catch all possible errors, to continue work event if bi event has some problems
    const eventSchema = _.get(biEventsCatalog, nameFromCatalog);

    if (!eventSchema) {
      throw new Error(`'${nameFromCatalog}' bi event was not found in catalog`);
    }

    return biEventVOD(eventSchema, params);
  });
}

export function sendError(nameFromCatalog, params) {
  return Promise.resolve().then(() => {
    // catch all possible errors, to continue work event if bi event has some problems
    const eventSchema = _.get(biErrorsCatalog, nameFromCatalog);

    if (!eventSchema) {
      throw new Error(`'${nameFromCatalog}' bi event was not found in catalog`);
    }

    return biSendError(eventSchema, params);
  });
}



// WEBPACK FOOTER //
// ./src/shared/bi/bi-facade.js